import React from 'react';
import BarChart from '../../../../Simple/echarts/BarChart/index-beta';
import { toSimpleChartData } from '../dataProcessor';

const MultipleCrossSimpleBarChart = ({
  data,
  legendsFilter,
  legendsFilterHandler,
  theme,
  themeTitle,
  fontSize,
  updateChartColors,
  colorPickerColors,
  error,
  chartType,
  chartRef,
  cardType,
}) => {
  const simpleChartData = toSimpleChartData(data);

  return (
    <BarChart
      data={simpleChartData}
      chartFontSize={fontSize}
      legendsFilter={legendsFilter}
      legendsFilterHandler={legendsFilterHandler}
      theme={theme}
      updateChartColors={updateChartColors}
      colors={theme.colors}
      colorPickerColors={colorPickerColors}
      themeTitle={themeTitle}
      // Os update preventers impedem a criação de uma nova instância do gráfico em algum ponto
      // quando altera o tema selecionado. Para isto foi acrescentado a propriedade "key"
      // para gerar uma nova instância do componente quando o tema mudar
      key={`${themeTitle}`}
      error={error}
      chartType={chartType}
      cardType={cardType}
      chartRef={chartRef}
    />
  );
};

export default MultipleCrossSimpleBarChart;
